import { OrderDetailResponse, OrderListResponse } from './types/order';
import { ApiFactoryClassType } from './factory';

const order = (factory: ApiFactoryClassType) => ({
    getOrderList: async (
        limit: number = 15,
        offset: number = 0,
        sort?: string,
        order?: string,
    ): Promise<OrderListResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/order/list?limit=${limit}&offset=${offset}${sort && order ? `&sort=${sort}&order=${order}` : ``}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
    getOrderById: async (id: string): Promise<OrderDetailResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(`/api/order/${id}`, factory.getApiHost()),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default order;
